<template>
    <DatatablePageLayout>
        <template v-slot:actionButtons>
                <vs-button 
                    class="rounded-lg xs:w-full sm:w-auto" 
                    :to="{ name: 'edit-webcam', params: { 'webcamUuid': '', 'webcam': {}} }" >
                    {{ $t("resorts.webcams.addwebcam") }}
                </vs-button>
        </template>
        <template v-slot:datatable>
            <Datatable 
                :config="datatableConfig"
                :elements="webcams"
                :stripe="true"
                :draggable="true"
                :sst="true"
                @action="action"
                @sort="sort"
                @filter="filter"
                @checkbox="publish"
            />
        </template>
    </DatatablePageLayout>
</template>

<script>

import WebcamService from '@/modules/Resorts/Services/WebcamService'
import Datatable from '@/modules/Shared/Components/table/SKDataTable.vue'
import PaginationService from '@/modules/Shared/Services/PaginationService'
import DatatablePageLayout from "@/modules/Shared/Pages/DatatablePageLayout"
import {unifyPaginatedResponse} from "@/modules/Shared/Helpers/apiResponseHelper"

export default {
    name: 'webcams',
    components: {
        DatatablePageLayout,
        Datatable
    },
    data () {
        return {
            resortUuid: '',
            webcams: [],
            datatableConfig: [
                { 'type': 'link', 'field': 'url', head: this.$t("resorts.webcams.url"), 'searchable': false, 'sortable': false },
                { 'type': 'text', 'field': 'name', head: this.$t("resorts.webcams.name"), 'searchable': false, 'sortable': false },
                { 'type': 'check', 'field': 'published', head: this.$t("resorts.webcams.visibility"), 'searchable': false, 'sortable': false },
                { 'type': 'text', 'field': 'timeofyear', head: this.$t("timeofyear"), 'searchable': false, 'sortable': false },
                { 'type': 'text', 'field': 'type', head: this.$t("resorts.webcams.type"), 'searchable': false, 'sortable': false },
                { 'type': 'image', 'field': 'thumbnail_url', head: this.$t("resorts.webcams.preview"), 'searchable': false, 'sortable': false },
                { 'type': 'actions', 'field': 'actions', head: this.$t("resorts.webcams.actions"), 'searchable': false, 'sortable': false }
            ],
        }
    },
    async created() {
        this.resortUuid = this.$route.params.uuid
        this.getWebcams({})
    },
    methods: {
        async publish(uuid, value, field) {
            await WebcamService.saveWebcam(this.resortUuid, uuid, { [field]: value })
        },
        sort(webcamsOrdered) {
            WebcamService.sortWebcams(this.resortUuid, webcamsOrdered)
        },
        async getWebcams(parameters) {
            const webcams = await unifyPaginatedResponse(
                page => WebcamService.getWebcams(this.resortUuid, { ...parameters, page })
            )
            this.webcams = webcams.map(
                webcam => ({...webcam, 'actions': [ 'delete', 'edit' ]})
            )
        },
        filter(params) {
            this.getWebcams(PaginationService.parseParameters(params))
        },
        action(type, uuid) {
            const webcam = this.webcams.filter(webcam => webcam.uuid === uuid)[0];
            switch(type) {
                case 'edit':   
                    this.$router.push({
                        name: 'edit-webcam',
                        params: {
                            'webcamUuid': webcam.uuid,
                            'webcam': webcam
                        }
                    });
                break;
                case 'delete':
                    this.deleteWebcam(uuid)
                break;
            }
        },
        async deleteWebcam(uuid) {
            this.$vs.loading()
            let response = await WebcamService.deleteWebcam(this.resortUuid, uuid)
            
            if(response.code == 200) {
                this.getWebcams({})
                this.$vs.notify( { text: this.$t("resorts.webcams.removed.ok"), color: 'success', position:'top-right' } )
            } else {
                this.$vs.notify( { text: this.$t("resorts.webcams.removed.ko"), color: 'danger', position:'top-right'} )
            }

            this.$vs.loading.close();
        }
    }
}
</script>
